/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Custom CARB Import Icon component.
 */
export const CarbImportIcon = (props: IconProps) => {
  const {color = dlsColor('aaBlue'), size = 22} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <path d="M12.6603 12.5021C14.1603 14.0021 14.6606 15.5021 15.6606 19.0021M6.5 6.5C6.5 6.5 12.619 7.46072 15.1602 10.002C16.1601 11.002 17.8228 14.9211 14.6606 16.5021C11.6604 18.0021 9.90202 16.5021 9 15C7.5 12.5021 6.5 6.5 6.5 6.5Z" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="15.3816" y1="1" x2="15.3816" y2="7" stroke={iconColor} strokeWidth="1.5"/>
      <line x1="15.6843" y1="6.25" x2="20.9475" y2="6.25" stroke={iconColor} strokeWidth="1.5"/>
      <path d="M4 0.75H15.3848L18.3252 3.54395L21.25 6.32129V22C21.25 22.6904 20.6904 23.25 20 23.25H4C3.30964 23.25 2.75 22.6904 2.75 22V2C2.75 1.30964 3.30964 0.75 4 0.75Z" stroke={iconColor} strokeWidth="1.5"/>
    </svg>
  );
};
